import { useEffect } from "preact/hooks";
import type { PageConfig, CalendarConfig } from "./types";
import WelcomeView from "./views/WelcomeView";
import UsernameView from "./views/UsernameView";
import App from "./App";

interface RootProps {
  config: PageConfig;
}

export default function Root({ config }: RootProps) {
  useEffect(() => {
    document.title =
      config.page === "welcome"
        ? "Meetday"
        : config.page === "username"
          ? "Set your name – Meetday"
          : "Calendar – Meetday";
  }, [config.page]);

  if (config.page === "welcome") {
    return <WelcomeView />;
  }

  if (config.page === "username") {
    return <UsernameView {...config} />;
  }

  // Calendar view: config is CalendarConfig
  const cal = config as CalendarConfig;
  return (
    <div className="flex flex-1 flex-col min-h-0 w-full">
      <App
        config={{
          slug: cal.slug,
          username: cal.username,
          month: cal.month,
          year: cal.year,
          selectedDate: cal.selectedDate,
          shareURL: cal.shareURL,
          vapidPublicKey: cal.vapidPublicKey,
          lastReadEventId: cal.lastReadEventId,
        }}
      />
    </div>
  );
}
